import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Submission } from 'src/types/shared/Assessments';

export const deleteUserApplicationRequest = createAction('deleteUserApplicationRequest');
export const deleteUserApplicationSuccess = createAction<Submission>(
    'deleteUserApplicationSuccess',
);
export const deleteUserApplicationFailure = createAction('deleteUserApplicationFailure');

export const deleteUserApplication = (application: Submission) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(deleteUserApplicationRequest());

    try {
        await api.delete(`admin/challengeapplications/${application.id}`);

        dispatch(deleteUserApplicationSuccess(application));
    } catch (e) {
        handleApiErrors(dispatch, deleteUserApplicationFailure, e);
    }
};
